/*
 * @创建人: 但志强
 * @修改人: 但志强
 * @描述: 获取系统id
 * @创建时间: 2019-07-24 16:43:10
 * @修改时间: 2019-08-15 14:38:04
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SwJwtService } from '../sw-jwt.service';


/**
 * 获取系统id 
 */
@Injectable()
export class SystemIdService {

  /**
   * @ignore
   */
  constructor(
    private jwt:SwJwtService, //本地缓存服务
  ) { }

  /**
   * 系统id 订阅
   */
  systemIdUpdated: Subject<any> = new Subject<any>();

    /**
   * admin用户修改租户信息时，对应的头部header系统信息也要及时更新
   */
  systemNameChanged: Subject<any> = new Subject<any>();
  /**
   * @ignore
   */
  private systemId:string =""

  /**
   * 获取系统id
   */
  getSystemId(){
    if(this.systemId == ""){
      this.systemId = this.jwt.getToken("systemId")
    }
    return this.systemId;
  }

  /**
   * 写入系统id
   * @param systemId  写入的系统id
   */
  setSystemId(systemId){
    this.systemId = systemId;
    // this.systemIdUpdated.next(this.systemId)
  }
}
